/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-17 13:02:05
 **/

import { useEffect } from "react";
import has from "lodash-es/has";
import { useProperties, Properties, GLOBAL_SELECTED_ID } from "@rsupport/libraries";
import { DeviceManager } from "@rsupport/devicemanager";
import { DeviceProvider } from "@/frameworks/core/components/Provider/permission/index";
import { Maybe } from "@/frameworks/libraries";

export default function UserOptionsProvider() {
	const selected = useProperties((state) => state.selected);
	const properties = useProperties((state) => state.properties[state.selected]);

	useEffect(() => {
		if (selected !== GLOBAL_SELECTED_ID) {
			if (!Properties.instance.has("graphic_options")) {
				Properties.instance.set("graphic_options", {
					quality: "LOW"
				});
			}
			if (!Properties.instance.has("device_options")) {
				Properties.instance.set("device_options", {
					video_enable: true,
					audio_enable: true,
					switch_new_device: true,
					use_noise_cancellation: true
				});
			}
			const device_options = Properties.instance.get("device_options");
			if (!has(device_options, "switch_new_device")) {
				Properties.instance.set("device_options", {
					switch_new_device: true
				});
			}
			if (!has(device_options, "use_noise_cancellation")) {
				Properties.instance.set("device_options", {
					use_noise_cancellation: true
				});
			}

			DeviceManager.instance.set_options({
				switch_new_device: Properties.instance.get<{
					video_enable: boolean;
					audio_enable: boolean;
					switch_new_device: boolean;
					use_noise_cancellation: boolean;
				}>("device_options").switch_new_device
			});
		}
	}, [selected]);

	useEffect(() => {
		console.debug("#UserOptionProvider# properties", selected, properties);
	}, [properties, selected]);

	return (
		<Maybe test={selected !== GLOBAL_SELECTED_ID && properties && has(properties, "graphic_options")}>
			<DeviceProvider />
		</Maybe>
	);
}
